/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Checklist item requirement: field value IN list ({field} in [{values}], eg docSubType in [DIPLOMATIC,SERVICE])
 * @export
 * @interface PaxCheckFieldIn
 */
export interface PaxCheckFieldIn {
    /**
     * Requirement represented as text
     * @type {string}
     * @memberof PaxCheckFieldIn
     */
    asText: string;
    /**
     * Field
     * @type {string}
     * @memberof PaxCheckFieldIn
     */
    field: string;
    /**
     * Allowed values
     * @type {Array<string>}
     * @memberof PaxCheckFieldIn
     */
    values: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof PaxCheckFieldIn
     */
    type: string;
}

/**
 * Check if a given object implements the PaxCheckFieldIn interface.
 */
export function instanceOfPaxCheckFieldIn(value: object): value is PaxCheckFieldIn {
    if (!('asText' in value) || value['asText'] === undefined) return false;
    if (!('field' in value) || value['field'] === undefined) return false;
    if (!('values' in value) || value['values'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function PaxCheckFieldInFromJSON(json: any): PaxCheckFieldIn {
    return PaxCheckFieldInFromJSONTyped(json, false);
}

export function PaxCheckFieldInFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckFieldIn {
    if (json == null) {
        return json;
    }
    return {
        
        'asText': json['as_text'],
        'field': json['field'],
        'values': json['values'],
        'type': json['type'],
    };
}

export function PaxCheckFieldInToJSON(json: any): PaxCheckFieldIn {
    return PaxCheckFieldInToJSONTyped(json, false);
}

export function PaxCheckFieldInToJSONTyped(value?: PaxCheckFieldIn | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'as_text': value['asText'],
        'field': value['field'],
        'values': value['values'],
        'type': value['type'],
    };
}

